
import axios from 'axios';
import isEng from './_isEng';

var https = require('https');

export default axios.create({
	//baseURL: isEng() ? 'http://admin.pechenyemorozova.ru/en' : 'http://admin.pechenyemorozova.ru'
	// baseURL: process.env.APP_BACK_PATH || 'http://admin.pechenyemorozova.ru:8083' || 'https://admin.pechenyemorozova.ru/',
	baseURL: 'https://admin.pechenyemorozova.ru',
	httpsAgent: new https.Agent({
		rejectUnauthorized: false
	})
	//baseURL: `http://${process.env.HOST || 'localhost'}:${process.env.PORT || 3000}/api`
});


//////////////////
// WEBPACK FOOTER
// ./plugins/axios.js
// module id = ./plugins/axios.js
// module chunks = 5